interface UnsavedIndicatorProps {
  isUnsaved: boolean;
}

const UnsavedIndicator = ({ isUnsaved }: UnsavedIndicatorProps) => {
  return (
    <div className="h-5 flex items-center">
      {isUnsaved && (
        <span className="inline-flex items-center gap-1.5 text-xs font-medium text-amber-600 bg-amber-50 px-2 py-0.5 rounded border border-amber-200">
          <span className="w-1.5 h-1.5 bg-amber-500 rounded-full animate-pulse"></span>
          Не сохранён
        </span>
      )}
    </div>
  );
};

export default UnsavedIndicator;